import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminUsers = async (params = {}) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.USERS.GET_ALL, { params });
    return response.data;
};

export const getAdminUserById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.USERS.GET_BY_ID(id));
    return response.data;
};

export const createAdminUser = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.USERS.CREATE, data);
    return response.data;
};

export const updateAdminUser = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.USERS.UPDATE(id), data);
    return response.data;
};

export const deleteAdminUser = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.USERS.DELETE(id));
    return response.data;
};
